var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThePig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pig_01",
    "data-name": "Pig 01",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 310,
    height: 160.707,
    viewBox: "0 0 310 160.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 110.549,
    cy: 24.116,
    rx: 110.549,
    ry: 24.116,
    transform: "translate(35.201 112.475)",
    opacity: 0.149,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(0 4.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M451.381,398.243a29.563,29.563,0,0,0,4.844,2.357,55.813,55.813,0,0,0,12.272,3.111l-3.114,7.868c-7.222-1.554-15.442-4.522-20.35-8.945Z",
    transform: "translate(-432.597 -383.155)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M460.377,402.841a18.925,18.925,0,0,1-7.182,5.052,51.3,51.3,0,0,0,10.972,4.5,17.756,17.756,0,0,0,.845-1.666,16.788,16.788,0,0,0,1.316-6.069A51.133,51.133,0,0,1,460.377,402.841Z",
    transform: "translate(-436.232 -385.205)",
    fill: "#c57b79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M435.044,390.487c-3.183-2.868-4.973-6.348-4.194-10.451,2.015-10.613,14.47-10.613,19.6-6.4s4.3,12.808-.184,17.748-20.7,10.064-27.657,1.281c11.906,1.281,20.727-.082,23.994-7.441,3.114-7.014-5.312-9.941-7.9-6.23-1.94,2.778-.444,5.13,2.694,7.106Z",
    transform: "translate(-422.608 -371.008)",
    fill: "#fec0bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M464.062,376.518a9.133,9.133,0,0,0-2.324-2.884c-3.187-2.616-9.2-3.6-13.785-1.431a25.221,25.221,0,0,0,14.609,4.358C463.067,376.561,463.567,376.543,464.062,376.518Z",
    transform: "translate(-433.897 -371.01)",
    fill: "#fed9d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(209.354 84.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M801.211,529.1c3.3,16.1,5.861,36.6,11.539,38.059a26.767,26.767,0,0,0,10.074.732c-1.465-6.953-4.03-16.1-4.579-27.446s1.282-25.983,1.282-25.983L800.112,518.3Z",
    transform: "translate(-800.112 -514.46)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M806.12,550.083c.56-1.647,1.113-3.3,1.569-4.975.392-1.44.662-2.9.96-4.364a52.467,52.467,0,0,1,1.852-7c1.511-4.283,3.968-8.551,8.175-10.494.39-5.1.851-8.786.851-8.786L800.112,518.3l1.1,10.8c1.5,7.32,2.847,15.544,4.4,22.479Q805.865,550.829,806.12,550.083Z",
    transform: "translate(-800.112 -514.46)",
    fill: "#c57b79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M812.741,592.2c1.536,5.3,3.329,9.035,5.635,9.629a26.763,26.763,0,0,0,10.074.732c-.557-2.642-1.272-5.6-1.975-8.879A25.551,25.551,0,0,1,812.741,592.2Z",
    transform: "translate(-805.737 -549.13)",
    fill: "#9d8686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(64.583 65.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M540.784,517.516c6.208,16.214,9.063,32.275,11.54,33.3,3.332,1.382,7.875,1.83,12.272,2.013-4.579-14.821-6.227-18.3-4.762-21.591s16.118-14.821,27.841-22.14-5.5-26.624-24.361-28.316S534.916,502.189,540.784,517.516Z",
    transform: "translate(-539.062 -480.695)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M555.743,589.706c1.62,5.5,2.857,9.25,4.011,9.729,3.332,1.382,7.875,1.83,12.272,2.013-1.063-3.438-1.965-6.26-2.709-8.617A23.052,23.052,0,0,1,555.743,589.706Z",
    transform: "translate(-546.492 -529.313)",
    fill: "#9d8686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(263.936 15.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M909.157,391.044c12.272.915,17.767.366,21.613-1.1-3.114,10.978-17.95,23.6-32.236,26.165Z",
    transform: "translate(-898.534 -389.947)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M913.845,410.7a28.072,28.072,0,0,0,3.773-7.156,20.6,20.6,0,0,0,1.188-6.461,43.032,43.032,0,0,0-.2-4.716c-2.621-.023-5.72-.165-9.448-.443L898.534,417Z",
    transform: "translate(-898.534 -390.831)",
    fill: "#c57b79"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M476,401.5c1.839-25.306,33.946-37.571,76.684-38.547s105.537,2.125,130.655,14.394c5.793,2.83,24.845,4.581,32.481,10.978,15.142,12.686,27.71,18.307,37.966,18.795l-8.9,25.364a48.957,48.957,0,0,1-13.432,3.416c-6.594.488-17.827,1.22-21.491,4.147s-17.1,15.126-34.19,20.493-55.437,7.563-96.465,5.611-59.589-12.443-70.822-18.3S473.8,431.749,476,401.5Z",
    transform: "translate(-446.324 -362.782)",
    fill: "#fec0bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M935.4,432.127c2.364,4.222,6.86,6.779,11.314,8.656,2.359.994,4.887,1.848,7.357,2.659.327.107.657.208.986.31l2.747-7.825c-6.9-.328-14.847-2.983-23.918-8.546A13.063,13.063,0,0,0,935.4,432.127Z",
    transform: "translate(-650.343 -391.593)",
    fill: "#fed9d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M563.68,520.078c5.312-.732,14.653-4.94,9.707-5.672a78.467,78.467,0,0,1-11.356-2.928s8.609-13.906,10.806-28.361l-.243-.112a34.244,34.244,0,0,0-9.281-2.222c-18.865-1.692-28.4,21.405-22.529,36.733,3.05,7.966,5.29,15.891,7.074,22.019.086-2.293.133-4.639.069-6.465-.183-5.306,2.747-8.417,4.762-10.613S558.368,520.809,563.68,520.078Z",
    transform: "translate(-474.48 -415.37)",
    fill: "#c57b79"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(265.946 44.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M909.374,490.692c-2.589,0-4.814-.057-6.676-.1a.554.554,0,0,1-.54-.568.548.548,0,0,1,.568-.54A165.653,165.653,0,0,0,934.68,487.6a.554.554,0,1,1,.171,1.095A162.783,162.783,0,0,1,909.374,490.692Z",
    transform: "translate(-902.158 -462.618)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M966.7,457.794c4.4-10.49,3.786-16.346.6-15.117-4.533,1.75-8.6,7.7-10.37,13.409-1.893,6.118-3.175,12.93,1.465,11.954S964.717,462.532,966.7,457.794Z",
    transform: "translate(-925.791 -442.515)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(31.707 5.001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 7.291,
    cy: 1.482,
    rx: 7.291,
    ry: 1.482,
    transform: "translate(0 15.354) rotate(-70.219)",
    fill: "#c57b79"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 4.452,
    cy: 0.975,
    rx: 4.452,
    ry: 0.975,
    transform: "translate(6.607 8.519) rotate(-73.093)",
    fill: "#c57b79"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(60.63 14.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M533.458,480c11.234,5.855,29.794,16.346,70.822,18.3,24.45,1.163,47.944.853,66.558-.724l-4.832-22.087L654.833,477.5c-32.786,5.489-47.805,3.659-63.374-1.647-.55-17.2-12.455-35.315-22.895-40.986l-36.629,44.349C532.463,479.483,532.973,479.745,533.458,480Z",
    transform: "translate(-531.935 -409.823)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M886.267,405.948q-3.493-2.548-7.187-5.637c-7.332-6.143-25.186-8-31.723-10.647-3.109,2.635-4.97,5.961-4.97,9.58,0,8.539,10.332,15.461,23.078,15.461C874.626,414.705,882.54,411.13,886.267,405.948Z",
    transform: "translate(-670.219 -389.664)",
    fill: "#ffa6a4"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 2.564,
    cy: 1.731,
    rx: 2.564,
    ry: 1.731,
    transform: "translate(261.372 32.447)",
    fill: "#c57b79"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(30.493 39.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M477.593,446.964c3.758,22.117,21.891,27.789,22.074,37.67s-8.609,11.161-5.312,21.957S499.3,529.1,502.6,531.109s6.777,3.66,14.287,3.66c-2.564-7.868-7.51-19.579-5.861-25.8s6.96-9.7,13.92-15.553,16.3-12.076,19.415-26.532,3.3-20.127,0-32.021C532.819,435.962,477.593,446.964,477.593,446.964Z",
    transform: "translate(-477.593 -434.864)",
    fill: "#fec0bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M567.141,434.864c3.3,11.894.366,21.408-3.3,31.289-5.141,13.865-12.638,18.3-19.6,24.153s-13.554,10.064-15.2,16.285,3.834,20.1,6.4,27.969a39.942,39.942,0,0,0,4.221.209c-2.564-7.868-7.51-19.578-5.861-25.8s6.96-9.7,13.92-15.553,16.3-12.076,19.415-26.532S570.438,446.758,567.141,434.864Z",
    transform: "translate(-500.375 -434.864)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M514.719,590.419c1.337,5.067,2.636,8.98,4.416,10.066,3.3,2.013,6.777,3.66,14.287,3.66-1.061-3.257-2.53-7.171-3.771-11.081A26.333,26.333,0,0,1,514.719,590.419Z",
    transform: "translate(-494.13 -504.239)",
    fill: "#9d8686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(183.528 65.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M753.543,498.008c2.93,12.076,8.426,28,11.539,38.242s3.3,19.213,8.792,20.494a23.291,23.291,0,0,0,10.257,0s-2.564-9.332-3.114-13.357c-1.323-9.692-2.342-19.912,3.114-23.878s7.326-3.019,8.059-5.581,3.114-25.8-9.158-30.923S757.206,481.54,753.543,498.008Z",
    transform: "translate(-753.543 -480.854)",
    fill: "#fec0bc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(22.912 20.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M798.626,526.639c-3.927,5.481-4.436,22.451-3.114,32.143.421,3.085,2.848,11.356,3.96,15.057a19.4,19.4,0,0,0,3.061-.48s-2.564-9.332-3.114-13.357c-1.323-9.692-2.342-19.912,3.114-23.877s7.326-3.02,8.059-5.582a45.511,45.511,0,0,0,.6-11.038c-.078-1.453-3.225-1.984-4.873-.555A51.519,51.519,0,0,0,798.626,526.639Z",
    transform: "translate(-794.857 -518.109)",
    fill: "#ffa6a4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M784.448,600.755a39.651,39.651,0,0,1-5.293-.958c1.308,5.317,2.661,9.186,6.127,9.994a23.292,23.292,0,0,0,10.257,0s-1.372-4.995-2.324-9.252A32.705,32.705,0,0,1,784.448,600.755Z",
    transform: "translate(-764.951 -533.901)",
    fill: "#9d8686"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M688.465,379.023a29.168,29.168,0,0,1-5.129-1.68c-25.118-12.27-87.918-15.37-130.655-14.394S477.835,376.19,476,401.5c-.69,9.5,1.15,17.029,4.346,23.067a33.8,33.8,0,0,1-.317-4.556c0-46.75,57.239-44.738,127.847-44.738,28.72,0,55.227,3.314,76.571,8.909C685.723,382.418,687.059,380.691,688.465,379.023Z",
    transform: "translate(-446.324 -362.782)",
    fill: "#fed9d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M832.373,385.309c1.186,9.478,18.133,14.821,35.533,9.332s26.925-23.055,26.925-23.055c-10.99,1.464-19.965-7.5-41.395-4.574S831.823,380.918,832.373,385.309Z",
    transform: "translate(-605.069 -364.405)",
    fill: "#fed9d6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThePig);
export default __webpack_public_path__ + "static/media/the-pig.17301e358980a4a31f5ae86eb7b8b390.svg";
export { ForwardRef as ReactComponent };